import { render, staticRenderFns } from "./page-meta.vue?vue&type=template&id=2d7dd8c2"
var script = {}
import style0 from "./page-meta.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports